var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadPdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.44a1.3 1.3 0 0 0-.06-.27v-.09c-.05-.1-.11-.2-.19-.28l-6-6a1.07 1.07 0 0 0-.28-.19h-.1a1.1 1.1 0 0 0-.31-.11H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9.44Zm-6-3.53 2.59 2.59H15a1 1 0 0 1-1-1V5.91Zm4 13.59a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v9Zm-4.71-4.71-.29.3V12.5a1 1 0 0 0-2 0v2.59l-.29-.3a1 1 0 1 0-1.42 1.42l2 2c.1.1.2.16.33.21a.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1 1 0 1 0-1.42-1.42Z",
    fill: "#DA0D29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdfIcon);
export default __webpack_public_path__ + "static/media/download-pdf-icon.e64ca056e769ac7859f179c0ac0eb9dc.svg";
export { ForwardRef as ReactComponent };